<div class="ribbon"
     [ngClass]="AppConfig.theme">
  <span>FREE</span>
</div>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/ui/ribbon/ribbon.component.html